export default {"src":"/_next/static/media/runner.fc6479bc.svg","height":278,"width":446,"blurWidth":0,"blurHeight":0};